import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { IUserWalletRewardItem } from '@share/common-types';

import './style.scss';

function formatValue(
  value: number | undefined,
  account: { walletNoDecimals?: boolean } | null | undefined
): string {
  if (value == null) return '—';
  const num = account?.walletNoDecimals ? Math.floor(value) : Math.floor(value * 100) / 100;
  return `$${num.toLocaleString('en-US', {
    minimumFractionDigits: account?.walletNoDecimals ? 0 : 2,
    maximumFractionDigits: account?.walletNoDecimals ? 0 : 2,
  })}`;
}

interface IProps {
  reward: IUserWalletRewardItem;
  account?: { walletNoDecimals?: boolean; name?: string } | null;
  searchHref: string | null;
  compact?: boolean;
}

export function WalletRewardReadyCard(props: IProps) {
  const { reward, account, searchHref, compact } = props;
  const amountFormatted = formatValue(reward.rewardValue, account);
  const expirationMoment = reward.expirationDate ? moment(reward.expirationDate) : null;
  const daysLeft =
    reward.daysUntilExpiration != null
      ? reward.daysUntilExpiration
      : expirationMoment?.isValid()
        ? Math.max(0, expirationMoment.diff(moment(), 'days'))
        : null;
  const isUrgent = daysLeft != null && daysLeft <= 7;
  const isSoon = daysLeft != null && daysLeft <= 30 && !isUrgent;

  return (
    <div
      className={`wallet-reward-ready-card ${compact ? 'wallet-reward-ready-card--compact' : ''} ${
        isUrgent ? 'wallet-reward-ready-card--urgent' : isSoon ? 'wallet-reward-ready-card--soon' : ''
      }`}
    >
      <p className="wallet-reward-ready-card__headline">
        <FormattedMessage id="wallet.header.rewardReady" values={{ amount: amountFormatted }} />
      </p>
      {daysLeft != null ? (
        <>
          <p className="wallet-reward-ready-card__expiry">
            <FormattedMessage id="wallet.header.expiresInDays" values={{ days: daysLeft }} />
          </p>
          {(isUrgent || isSoon) && (
            <p className="wallet-reward-ready-card__nudge">
              {isUrgent ? (
                <FormattedMessage id="wallet.header.expiresSoon" />
              ) : (
                <FormattedMessage id="wallet.header.dontMissIt" />
              )}
            </p>
          )}
        </>
      ) : null}
      {searchHref && (
        <Link to={searchHref} className="wallet-reward-ready-card__cta">
          <FormattedMessage id="wallet.header.useRewardNow" />
        </Link>
      )}
    </div>
  );
}
